import { ReactComponent as FlagIcon } from "./svg/tr-flag.svg";
import "../flag-icon.scss";

export const TRFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
